import { Injectable, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
} from '@angular/forms';

@Injectable()
export class NewOrganizationContactFormModel {

  form: FormGroup;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group({
      newContactId: new FormControl()
    });
  }
}
